import { DOCUMENT } from "@angular/common";
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { ProcessingLog } from "src/app/core/models/processingLog.model";
import { UserUpdate } from "src/app/core/models/user.model";
import { ProcessingLogService } from "src/app/core/services/processingLog.service";
import { ServiceProviderService } from "src/app/core/services/serviceProvider.service";
import { UserService } from "src/app/core/services/user.service";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "../../core/services/auth.service";
import { AuthfakeauthenticationService } from "../../core/services/authfake.service";
import { LanguageService } from "../../core/services/language.service";

interface Language {
  text: string;
  flag: string;
  lang: string;
  value: number;
}

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit, OnDestroy {
  username: string;
  profile: string;
  user: any;
  element: any;
  cookieValue: string;
  countryName: string;
  flagvalue: string;
  serviceProviders: any[] = [];
  selectedserviceProvider: any;
  version: string = environment.version;
  serviceProviderIdSelected: any;
  openMobileMenu: boolean;
  unreadCount: number = 0;
  recentLogs: ProcessingLog[] = [];
  private notificationInterval: any;
  // headquartersServiceProviders: any[] = [];
  // isHeadquarter: boolean = false;

  listLang: Language[] = [
    {
      text: "Português",
      flag: "assets/images/flags/br.png",
      lang: "pt",
      value: 1,
    },
    {
      text: "English",
      flag: "assets/images/flags/us.jpg",
      lang: "en",
      value: 2,
    },
    {
      text: "Español",
      flag: "assets/images/flags/spain.jpg",
      lang: "es",
      value: 3,
    },
  ];

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public serviceProviderService: ServiceProviderService,
    public userService: UserService,
    public ngxSpinner: NgxSpinnerService,
    public toastr: ToastrService,
    private processingLogService: ProcessingLogService,
  ) {}

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.getUserName();
    this.initializeLanguage();
    this.loadUnreadCount();
    this.notificationInterval = setInterval(() => {
      this.loadUnreadCount();
    }, 60000); // Polling a cada 60 segundos
  }

  ngOnDestroy() {
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }
  }

  loadUnreadCount() {
    this.processingLogService.getUnreadCount().subscribe({
      next: (response) => {
        if (response.isSuccessful) {
          this.unreadCount = response.data[0] || 0;
        }
      },
      error: () => {},
    });
  }

  onNotificationBellClick() {
    this.processingLogService
      .filterProcessingLogs({ isRead: false })
      .subscribe({
        next: (response) => {
          if (response.isSuccessful) {
            this.recentLogs = (response.data || []).slice(0, 5);
          }
        },
        error: () => {},
      });
  }

  onNotificationClick(log: ProcessingLog) {
    if (!log.isRead) {
      this.processingLogService.markAsRead(log.processingLogId).subscribe({
        next: () => {
          log.isRead = true;
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        },
      });
    }
  }

  markAllNotificationsAsRead() {
    this.processingLogService.markAllAsRead().subscribe({
      next: (response) => {
        if (response.isSuccessful) {
          this.unreadCount = 0;
          this.recentLogs.forEach((log) => (log.isRead = true));
        }
      },
    });
  }

  /**
   * Inicializa a linguagem baseado no usuário do localStorage
   */
  initializeLanguage() {
    // Pega a linguagem do usuário (que já vem do localStorage via getUserName)
    if (this.user?.language !== null && this.user?.language !== undefined) {
      const userLang = this.listLang.find(
        (x) => x.value === this.user.language,
      );
      if (userLang) {
        this.cookieValue = userLang.lang;
      }
    }

    // Se não encontrou linguagem do usuário, usa português como padrão
    if (!this.cookieValue) {
      this.cookieValue = "pt";
    }

    // Define os valores da flag e nome do país
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text)[0];

    if (val.length === 0) {
      this.flagvalue = "assets/images/flags/br.png";
    } else {
      this.flagvalue = val.map((element) => element.flag)[0];
    }

    // Sempre aplica a linguagem
    this.languageService.setLanguage(this.cookieValue);
  }

  getUserName() {
    const user = this.authFackservice.getUser();
    this.username = user.name;
    this.profile = user.profileWkf;
    this.user = user;

    this.getServiceProviders();
  }

  getServiceProviders() {
    this.serviceProviderService
      .getServiceProvidersByTenant(this.user.tenant.tenantId)
      .subscribe((response) => {
        // Todos os prestadores ativos
        this.serviceProviders = response.data.filter((sp) => sp.flActive);

        // const currentExternalCode = this.user?.serviceProvider?.externalCode;

        // // 🔹 Matriz + filiais da mesma matriz
        // this.headquartersServiceProviders = this.serviceProviders.filter(
        //   (sp) =>
        //     sp.headquartersCode === currentExternalCode ||
        //     sp.externalCode === currentExternalCode
        // );

        // this.isHeadquarter = this.headquartersServiceProviders.length > 1;

        // 🔹 Tenta pegar do localStorage primeiro
        const storedId = localStorage.getItem("serviceProviderIdSelected");
        const parsedStoredId = storedId ? JSON.parse(storedId) : null;

        // 🔹 Escolhe a lista disponível baseado no tipo de usuário
        // const availableProviders = this.isHeadquarter
        //   ? this.headquartersServiceProviders
        //   : this.serviceProviders;
        const availableProviders = this.serviceProviders;

        // 🔹 Define o prestador selecionado seguindo esta ordem de prioridade:
        // 1. localStorage (se válido)
        // 2. Prestador atual do usuário
        // 3. Primeiro da lista disponível
        if (
          parsedStoredId &&
          availableProviders.find(
            (sp) => sp.serviceProviderId === parsedStoredId,
          )
        ) {
          this.serviceProviderIdSelected = parsedStoredId;
        } else if (
          this.user?.serviceProvider?.serviceProviderId &&
          availableProviders.find(
            (sp) =>
              sp.serviceProviderId ===
              this.user.serviceProvider.serviceProviderId,
          )
        ) {
          this.serviceProviderIdSelected =
            this.user.serviceProvider.serviceProviderId;
          localStorage.setItem(
            "serviceProviderIdSelected",
            JSON.stringify(this.serviceProviderIdSelected),
          );
        } else if (availableProviders.length > 0) {
          this.serviceProviderIdSelected =
            availableProviders[0].serviceProviderId;
          localStorage.setItem(
            "serviceProviderIdSelected",
            JSON.stringify(this.serviceProviderIdSelected),
          );
        }
      });
  }

  onServiceProviderChange(event: any) {
    // 🔹 O ng-select passa o serviceProviderId diretamente no ngModelChange
    const selectedId = event;

    // 🔹 Atualiza imediatamente para refletir visualmente no select
    const previousId = this.serviceProviderIdSelected;
    this.serviceProviderIdSelected = selectedId;

    this.ngxSpinner.show();

    // 🔹 Busca o provider na lista correta
    // const providersList = this.isHeadquarter
    //   ? this.headquartersServiceProviders
    //   : this.serviceProviders;
    const providersList = this.serviceProviders;

    const provider = providersList.find(
      (sp) => sp.serviceProviderId === selectedId,
    );

    if (!provider) {
      console.error("❌ Provider não encontrado:", selectedId);
      this.serviceProviderIdSelected = previousId;
      this.handleServiceProviderError(this.translate.instant("TOPBAR.ERRORS.SERVICE_PROVIDER_NOT_FOUND"));
      return;
    }

    this.selectedserviceProvider = provider;

    const userUpdate = this.createUserUpdate(this.user);

    this.userService.updateUser(this.user.userId, userUpdate).subscribe({
      next: (response) => {
        if (response.isSuccessful) {
          this.user.serviceProvider.serviceProviderId =
            provider.serviceProviderId;

          localStorage.setItem(
            "serviceProviderIdSelected",
            JSON.stringify(provider.serviceProviderId),
          );

          // Força o reload
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          console.error("❌ Update falhou:", response.messageDescription);
          this.serviceProviderIdSelected = previousId;
          this.handleServiceProviderError(response.messageDescription);
        }
      },
      error: (err) => {
        console.error("❌ Erro no updateUser:", err);
        this.serviceProviderIdSelected = previousId;
        this.handleServiceProviderError(
          this.translate.instant("TOPBAR.ERRORS.UPDATE_SERVICE_PROVIDER"),
        );
      },
    });
  }

  private handleServiceProviderError(message: string) {
    this.toastr.error(message);
    this.ngxSpinner.hide();
  }

  createUserUpdate(user: any): UserUpdate {
    const userUpdate = new UserUpdate();
    userUpdate.serviceProviderId =
      this.selectedserviceProvider.serviceProviderId;
    userUpdate.flActive = true;
    return userUpdate;
  }

  /**
   * Define a linguagem selecionada
   */
  setLanguage(text: string, lang: string, flag: string, value: number) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
    this.saveUserLanguage(value);
  }

  /**
   * Salva a linguagem do usuário no banco de dados
   */
  saveUserLanguage(languageValue: number) {
    this.ngxSpinner.show();

    const userUpdate = new UserUpdate();
    userUpdate.serviceProviderId = this.user.serviceProvider.serviceProviderId;
    userUpdate.flActive = true;
    userUpdate.language = languageValue;

    this.userService.updateUser(this.user.userId, userUpdate).subscribe({
      next: (response) => {
        if (response.isSuccessful) {
          this.user = response.data[0];
          this.authFackservice.updateUserLanguage(this.user);
          this.user.language = languageValue;

          this.toastr.success(
            this.translate.instant("TOAST.LANGUAGE_CHANGED_SUCCESS"),
          );

          // Recarrega a página para aplicar as traduções
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          this.toastr.error(response.messageDescription);
          this.ngxSpinner.hide();
        }
      },
      error: (err) => {
        this.toastr.error(this.translate.instant("TOPBAR.ERRORS.UPDATE_LANGUAGE"));
        this.ngxSpinner.hide();
      },
    });
  }

  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    localStorage.removeItem("serviceProviderIdSelected");

    if (environment.defaultauth === "firebase") {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(["/account/login"]);
  }

  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }
}
